import { SEnumType } from './enum-type';
import { assignSafe } from './functions/assign-safe';

export class EnumSelect {
  id?: number | string;
  value?: string;

  constructor(jsonData: Partial<EnumSelect>) {
    assignSafe(this, jsonData);
  }

  static ToIdList(enumObject: SEnumType): number[] {
    return Object.keys(enumObject)
      .map((x) => Number(x))
      .filter((x) => !Number.isNaN(x));
  }

  static ToIdListExclude(enumObject: SEnumType, excluded: Array<number>): number[] {
    return this.ToIdList(enumObject).filter((x) => !excluded.includes(x));
  }

  static ToIdListFilter(enumObject: SEnumType, include: Array<number>): number[] {
    return this.ToIdList(enumObject).filter((x) => include.includes(x));
  }

  toShortString(): string | undefined {
    return this.value;
  }
}
